module.exports = __webpack_public_path__ + "img/unparalleled-effectiveness.7aee28a9.jpg";